export enum EWebsocketTypes {
    ACHIEVEMENT = "SocketMessageAchievementDto",
    STUDENT = "SocketMessageStudentDto",
    NOTIFICATION = "SocketMessageNotificationDto",
    NEWS = "SocketMessageNewsDto",
    RATING = "SocketMessageRatingDto",
    MESSAGE = "SocketMessageActionDto",
    OTHER = "SocketMessageOtherDto",
}
